import { Rocket, Tag, Swords, Landmark, Megaphone } from "lucide-react";

// Icon + one-line brief for each problem type. Keeps the client neutral
// about the framework internals.
export const PROBLEM_TYPE_META = {
  market_entry: {
    icon: Rocket,
    tagline: "Should we enter this market — and how?",
  },
  pricing_strategy: {
    icon: Tag,
    tagline: "How do we price to win and defend margin?",
  },
  competitive_assessment: {
    icon: Swords,
    tagline: "Where do we actually beat — and lose to — rivals?",
  },
  investment_diligence: {
    icon: Landmark,
    tagline: "Is this asset worth underwriting at this price?",
  },
  gtm_launch: {
    icon: Megaphone,
    tagline: "How do we launch to convert, not just to ship?",
  },
};

export const ENGINE_STEPS = [
  "Reading your case",
  "Mapping to the framework",
  "Finding blind spots",
  "Searching and validating",
];
